import axios from "axios";
import { baseUrl } from "../../utils/sysEnv";
import * as types from '../types'
import { toast } from "react-toastify";
import { authToken } from "../../utils/helper";



// GET ALL logs
export const getLogs = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${baseUrl}/logs`, authToken(info.token))
        .then((res) => {
            
          dispatch({
            type: types.GET_LOGS,
            payload: res.data.data,
          });
          dispatch({ type: types.RESET_LOADING });
        })
        .catch((error) => {
          if (error.response === undefined) {
            // toast.error(error.message);
            //   setError(dispatch, error.message)
          } else {
            //  toast.error(error.message);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (err) {
       toast.error(err.message);
    }
  };

  